/* eslint-disable */
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import dealdata from './MyData.json';
// import categorydata from './MyCategory.json';
import { Card, CardBody, CardHeader, Container, FormGroup, Input, Label } from 'reactstrap';
import { getCurrentUser, getToken } from '../Auth';
import { useEffect } from 'react';
// import { json } from 'react-router-dom';
import UserService from '../services/UserService';
// import { createDeal, postDataApi ,getCategory} from '../services/DealService';
import axios from 'axios';


function AddDeals() {

  
  const [deal, setDeal] = useState({
    storeId: 0,
    categoryId: 0,
    file: '',
    commondiscription:''   
  },[])
  const[displayDeal,SetDisplayDeal]=useState([]);

  const[togelDeal,SetTogelDeal]=useState(false);
  // new: true while a sub-deal is being saved
  const[savingSubDeal,setSavingSubDeal]=useState(false);
  const[subDeal,setSubDeal]=useState({
     link: '',
    imagefile: '',
     title: '',
    price: '',
    regularprice:'',
  // old: discription:'',
  // new: the backend expects "subdealdiscription" (it rejects the sub-deal if this field is missing)
  subdealdiscription:'',
    promocode: '',
    active: '',
    // date:new Date(),
    endingdate: '',
    
  })

  const[categoryData,SetCategory]=useState([]);
  const[storeData,SetStore]=useState([]);
  useEffect(()=>{

     UserService.getStore().then((res)=>SetStore(res.data))
     UserService.getCategory().then((res)=>SetCategory(res.data))
    // old: },[subDeal]);
    // new: load stores and categories ONCE. With [subDeal] they were downloaded again on every key you typed (very slow).
    },[]);
  

  const[user,setUser]=useState(undefined)
  const changingTogelDeal=(e)=>{
    SetTogelDeal(false)
  }

  const resetSubdeal = (e) => {
      setSubDeal({
      link: '',
    imagefile: '',
     title: '',
    // new: keep price fields after reset (the backend needs them for the next sub-deal)
    price: '',
    regularprice: '',
    subdealdiscription: '',
    subdealcommondiscription:'',
    promocode: '',
    active: '',
    // date:new Date(),
    endingdate: '',
    })

  }
  const [error, setErrors] = useState({
    errors: {},
    isError: false
  }) 

  const handleChange = (e) => { 
    setDeal({...deal, [e.target.name]: e.target.value })   
  } 
  const subdealhandleChange = (e) => {  
    
    setSubDeal({...subDeal, [e.target.name]: e.target.value })
    //  console.log(subDeal)
  }
//++++++++++++++++submit deal
  const submitDeal = (e) => {    
    e.preventDefault();
    var today=new Date().getDate();
    // console.log(deal)
    setDeal({...deal,date:today})
    if (error.isError) {    
      // Toast.error(error.errors);
      console.log(error.errors)
      return;
    }
      try { 
        // axios.post("http://localhost:8080/api/deal/"+getCurrentUser().user_id, deal,{  
         axios.post(UserService.getURl()+"/deal/"+getCurrentUser().user_id, deal,{
          headers: { Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
           Authorization: `Bearer ${getToken()}` }
         })      
           .then(response => {
             if (response.data != null) {
            //  console.log(response.data)
             SetDisplayDeal(response.data)
               alert("deal Saved successfully")
               SetTogelDeal(true);
               resetdeal();
               }
             }
           )
           // new: show why the deal was not saved (before, nothing was shown)
           .catch(err => {
             console.error("Deal save failed", err)
             const status = err.response && err.response.status
             if (status === 400) {
               alert("Deal NOT saved: choose a store, a category, an image and write a description.")
             } else if (status === 401 || status === 403) {
               alert("Deal NOT saved: you are logged out. Please log in again.")
             } else {
               alert("Deal NOT saved. The server may be waking up, please wait a minute and try again.")
             }
           });
       } catch (error) {
        alert(error)
         console.log(error);
       }
    }
    //+++++++++++++++++++submit subdeal
    const submitSubDeal = (e) => {    
      e.preventDefault();  
      var today=new Date().getDate();
      // console.log(subDeal)
      setDeal({...subDeal,date:today})
      // console.log("deal id is"+displayDeal.id)
      if (error.isError) {
        console.log(error.errors)
        return;
      }
      // new: the backend needs an image for every sub-deal, so check before sending
      if (!subDeal.imagefile) {
        alert("Please choose an image for this sub-deal.")
        return;
      }
      // new: show "Saving..." and stop double clicks while the backend works
      if (savingSubDeal) return;
      setSavingSubDeal(true)
        try {
            axios.post(UserService.getURl()+"/subdeal/"+displayDeal.id, subDeal,{
            
            headers: { Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
             Authorization: `Bearer ${getToken()}` }
           })       
             .then(response => {
               if (response.data != null) {
                 alert("deal Saved successfully and enter Subdeal Data")
                 resetSubdeal();
                 }
               }
             )
             // new: before, errors were never shown, so a failed save looked like "nothing happens"
             .catch(err => {
               console.error("Sub-deal save failed", err)
               const status = err.response && err.response.status
               if (status === 400) {
                 alert("Sub-deal NOT saved: a field is missing. Fill in link, image, title, price, regular price and description.")
               } else if (status === 401 || status === 403) {
                 alert("Sub-deal NOT saved: you are logged out. Please log in again.")
               } else {
                 alert("Sub-deal NOT saved. The server may be waking up, please wait a minute and try again.")
               }
             })
             .finally(() => setSavingSubDeal(false));
         } catch (error) {
          alert(error)
           console.log(error);
         }
      }
  const handleValidation = () => {
    console.log(" i am in handlevalidation")
    if (!deal.storeId) {
      setErrors({
        errors:"store is blank",
        isError:true
      })
    }

    // console.log(this.state.category)
    if (!deal.categoryId) {
      setErrors({
        errors:"store is blank",
        isError:true
      })
    }   
    if (!deal.link) {
      setErrors({
        errors:"store is blank",
        isError:true
      })
    }

    console.log(this.state.image)
    if (!deal.image) {
      setErrors({
        errors:"store is blank",
        isError:true
      })
    }
    if (!deal.title) {
      setErrors({
        errors:"store is blank",
        isError:true
      })
    }

    if (!deal.discription) {
      setErrors({
        errors:"store is blank",
        isError:true
      })
    }
    return error;
  }
  const fileChange=(e)=>{    
    setDeal({ ...deal, [e.target.name]: e.target.files[0] })  
  }
  const subdealfileChange=(e)=>{    
    setSubDeal({ ...subDeal, [e.target.name]: e.target.files[0] })  
  }
  const resetdeal = () => {
    setDeal({
      store: '',
      category: '',     
      image: '',     
      commondiscription: '',      
    })
  }

if(!togelDeal){
 
  return(<>
      <Container>
        <Card >
          <CardHeader>
            <h3>Enter Deals Details</h3>
          </CardHeader>
          <CardBody>
            {/* {JSON.stringify(deal)} */}

            {/* about deal data form */}
            <Form method='post' id="form1" onSubmit={submitDeal}>
              <Row>
                <Col md={3}>
                  <FormGroup >
                    {/* <Label for="example select">Select Store</Label> */}
                    <Input id="storeSelect" name="storeId" type="select" onChange={handleChange} defaultValue={0}>
                      <option disabled value={0}>Select Store</option>
                      {storeData.map((data) =>
                        <option key={data.store_id} value={data.store_id} >{data.store}</option>)}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup >
                    {/* <Label for="example select">Select Category</Label> */}
                    <Input id="categorySelect" name="categoryId" type="select" onChange={handleChange} defaultValue={0}>
                      <option disabled value={0}>Select Category</option>
                      {categoryData.map((data, i) =>
                        <option key={data.category_id} value={data.category_id}>{data.category}</option>)}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup >
                    {/* <Label>Select your image</Label> */}
                    <Input id="fileSelect" type="file" name='file' onChange={fileChange} />
                  </FormGroup>
                </Col> </Row>
              {/*common description */}
              <FormGroup >
                <Label>CommonDiscription</Label>
                <Input id="commondiscripationSelect" type="text" name='commondiscription' onChange={handleChange} />

              </FormGroup>

              <Container className="text-center">
                <Button variant="primary" style={{ marginRight: "10px" }} type="submit" >
                  Submit
                </Button>
                <Button variant="primary"  style={{ margin: "10px" }} >
                  Reset
                </Button>

                <Button variant="primary" style={{ margin: "10px" }} >Cancel
                </Button>
              </Container>
              </Form>
          </CardBody>
        </Card>
      </Container>
    </>
                     )
  
}else{
  return(
    <>
    <p>{displayDeal.category.category}                   {displayDeal.store.store}</p>
    
   <p>{displayDeal.commondiscription}
    <img  src={displayDeal.imageurl} alt="dealimage" style={{width:'150px'}}></img></p>
      <Card id="cardSubdeal"  >
        <CardHeader>Enter SubDeal</CardHeader>
        <CardBody>
          <Form method='post' id="form2" onSubmit={submitSubDeal}>
            {/* link */}
            <FormGroup>
              <Label>Link</Label>
              <Input id="emailSelect" value={subDeal.link} type="text" name='link' onChange={subdealhandleChange} />
            </FormGroup>

            {/* subdeal image */}
            <FormGroup >
              <Label>Select your image</Label>
              <Input id="fileSelect"  type="file" name='imagefile' onChange={subdealfileChange} />
            </FormGroup>
            {/* title */}

            <FormGroup >
              <Label>Title</Label>
              <Input id="titleSelect" value={subDeal.title} type="text" name='title' onChange={subdealhandleChange} />

            </FormGroup>

            {/* description */}
            <FormGroup >
              <Label>Price</Label>
              <Input id="priceSelect" value={subDeal.price} type="text" name='price' onChange={subdealhandleChange} />
            </FormGroup>
            <FormGroup >
              <Label>Price</Label>
              <Input id="regularpriceSelect" value={subDeal.regularprice} type="text" name='regularprice' onChange={subdealhandleChange} />
            </FormGroup>
            {/* common discription */}
            <FormGroup >
              <Label> Discription</Label>
              <Input id="subdealcommondiscripationSelect" value={subDeal.subdealdiscription} type="text" name='subdealdiscription' onChange={subdealhandleChange} />
            </FormGroup>

            <Row>
              <Col md={6}>
                {/* promocode */}
                <FormGroup as={Col} >
                  <Form.Label>Promocode</Form.Label>
                  <Input id="promocodeSelect" type="text" value={subDeal.promocode} name='promocode' onChange={subdealhandleChange} placeholder="Promocode" />

                </FormGroup>
              </Col>
              <Col md={6}>
                {/* radio button active or inactive */}
                {/* old: <FormGroup check onChange={subdealhandleChange}>
                  <Input name="radio1" type="radio" onChange={subdealhandleChange} />
                  <Label check> active</Label>
                </FormGroup>
                <FormGroup check onChange={subdealhandleChange}>
                  <Input name="radio1" type="radio" onChange={subdealhandleChange} />
                  <Label check> Inactive</Label>
                </FormGroup> */}
                {/* new: name="active" + value, so the choice is really saved (before it went to "radio1") */}
                <FormGroup check>
                  <Input name="active" type="radio" value="active" checked={subDeal.active === 'active'} onChange={subdealhandleChange} />
                  {''}
                  <Label check> active</Label>
                </FormGroup>

                <FormGroup check>
                  <Input name="active" type="radio" value="inactive" checked={subDeal.active === 'inactive'} onChange={subdealhandleChange} />
                  {''}
                  <Label check> Inactive</Label>
                </FormGroup>
              </Col>
            </Row>
            <Label>Select Deal End Date and Time </Label>
            <Row>
              <Col md={6}>
                <FormGroup >
                  <Input id="dateSelect" type="date" name="endingdate" onChange={subdealhandleChange}></Input>
                </FormGroup>
              </Col>
              <Container className="text-center">
                {/* old: <Button variant="primary" style={{ marginRight: "10px" }} type="submit" >Add Subdeal</Button> */}
                {/* new: shows "Saving..." while the backend works */}
                <Button variant="primary" style={{ marginRight: "10px" }} type="submit" disabled={savingSubDeal} >
                  {savingSubDeal ? "Saving..." : "Add Subdeal"}
                </Button>
                <Button variant="primary" type="reset" style={{ margin: "10px" }} >
                  Reset
                </Button>

                <Button variant="primary" style={{ margin: "10px" }} >Cancel
                </Button>
                {/* old: <Button variant="primary" style={{ marginRight: "10px" }} type="submit" onClick={changingTogelDeal} > */}
                {/* new: type="button" so it doesn't also submit the sub-deal form */}
                <Button variant="primary" style={{ marginRight: "10px" }} type="button" onClick={changingTogelDeal} >
                  Add New DEAL
                </Button>
              </Container>
            </Row>
          </Form>
          </CardBody>
          </Card>             
           
                  
  
      </>)
}

}
export default AddDeals;